import { FunctionComponent } from "react";

import {
  DefaultButton,
  Dialog,
  Spinner,
  Stack,
  Text,
  useTheme
} from "@bps/fluent-ui";
import { CopyableGuid } from "@components/CopyableText";
import { SectionTitle } from "@components/SectionTitle";
import {
  useCanUnlinkTenant,
  useUnlinkTenant
} from "@libs/api/gateways/plt/plt-gateway.hooks";

import { ManageTenantDialogProps } from "./ManageTenantDialog.types";

export const ManageTenantDialog: FunctionComponent<ManageTenantDialogProps> = ({
  tenant,
  onDismiss,
  onUnlinked
}) => {
  const apiArgs = {
    tenantId: tenant.customerTenantId ?? "",
    childTenantId: tenant.id
  };

  const theme = useTheme();
  const { data, isLoading, error } = useCanUnlinkTenant(apiArgs);
  const unlinkTenant = useUnlinkTenant(apiArgs);

  const confirmUnlink = async () => {
    const unlink = confirm("Are you sure you want to unlink this tenant?");
    if (unlink) {
      await unlinkTenant.mutateAsync(apiArgs);
      onUnlinked();
    }
  };

  const TenantDetails = () => (
    <Stack tokens={{ childrenGap: 8 }}>
      <SectionTitle>{tenant.name}</SectionTitle>
      <CopyableGuid
        value={tenant.id}
        variant="small"
        color={theme.palette.themeSecondary}
      />
    </Stack>
  );
  return (
    <Dialog
      hidden={false}
      onDismiss={onDismiss}
      dialogContentProps={{ title: "Manage Tenant", showCloseButton: true }}
    >
      {isLoading && <Spinner />}
      {error && <h1>Error loading details for tenant</h1>}
      <TenantDetails />

      {data?.canUnlink ? (
        <DefaultButton onClick={() => confirmUnlink()}>
          Unlink Tenant
        </DefaultButton>
      ) : (
        <Text>{data?.reason}</Text>
      )}
    </Dialog>
  );
};
